<template>
  <div class="home">
    <div class="company_title"></div>
    <div class="company_content"><div class="text">
      <p>湖北盛淼通网络信息科技有限公司，成立于2024年12月，是一家专注于网络技术服务和信息技术服务的创新型企业，致力于在 AI 直播带货和跨境电商领域创造卓越价值。</p> 
      <p style="margin-top: 3%;">公司核心业务AI 直播带货和跨境电商，借助前沿的人工智能技术，打造生动、高效的直播场景，为产品销售注入新活力，我们整合优势资源，搭建跨境贸易桥梁，助力企业拓展全球市场。</p>
</div></div>
    
    <!-- 导航条 -->
    <!-- <van-nav-bar title="首页" fixed /> -->

    <!-- 搜索框 -->
    <!-- <van-search
      readonly
      shape="round"
      background="#f1f1f2"
      placeholder="请在此输入搜索关键词"
      @click="$router.push('/search')"
    /> -->

    <!-- 轮播图 -->
    <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.id">
        <img :src="item.image" alt="" />
      </van-swipe-item>
    </van-swipe> -->

    <!-- 导航 -->
    <!-- <van-grid column-num="4" icon-size="50">
      <van-grid-item
        v-for="item in navList"
        :key="item.imgUrl"
        :icon="item.imgUrl"
        :text="item.text"
        @click="$router.push(item.path)"
      />
    </van-grid> -->

    <!-- 主会场 -->
    <!-- <div class="main">
      <img src="@/assets/main.png" alt="" />
    </div> -->

    <!-- 猜你喜欢 -->
    <!-- <div class="guess">
      <p class="guess-title">—— 猜你喜欢 ——</p>
    </div> -->
  </div>
</template>

<script>
import GoodsItem from "@/components/GoodsItem.vue";
import {getHomeData, getHomeBanner, getHomeNav,getHomeGoods} from "@/api/home";
export default {
  name: "HomePage",
  components: {
    GoodsItem,
  },
  data() {
    return {
      bannerList: [require('@/assets/img/home_11.png'),], //轮播
      noticeStr: '<p>运营阶段(全周期)<br>直播执行:<br>-每日3场直播(五到八小时/场),覆盖流量高峰时段<br>-AI智能话术+真人助播配合<br></p><p>流量投放:<br>-千川/GDPA精准投放<br>-违规流量实时补偿(72小时内重置)</p><p>数据复盘:<br>-每周发送运营报告(GMV/ROI/粉丝增长)<br>-每月1次策略升级会议</p>',
      navList: [], //导航
      proList: [], //商品
    };
  },
  async created() {

    // getHomeBanner().then(resp => {
    //     this.bannerList = resp.data;
    // }).catch(error => {
    //   console.error("Error fetching banner data:", error);
    // });

    // getHomeNav().then(resp => {
    //   this.navList = resp.data;
    // })
    // getHomeGoods().then(resp => {
    //   this.proList = resp.data;
    // })
    // const {
    //   data: { pageData },
    // } = await getHomeData();
    // this.bannerList = pageData.items[1].data;
    // this.navList = pageData.items[3].data;
    // this.proList = pageData.items[6].data;
    // console.log(this.bannerList);
  },
};
</script>

<style lang="less" scoped>
// 主题 padding
.home {
  // padding-top: 100px;
  // padding-bottom: 50px;
  // background: url(@/assets/img/index_bg.png);
  // background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  background: url(@/assets/img/index_bg.png) no-repeat left center;
  background-size: 100% 100%;
  overflow: hidden;
}
.company_title {
  background: url(@/assets/img/company_title_bg.png) no-repeat left center;
  background-size: 100% 100%;
  
  height: 11%;
  width: 67%;
  margin: 0 auto;
  margin-top: 17%;
  color: #dcdee0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.company_content {
  background: url(@/assets/img/company_content_bg.png) no-repeat left center;
  background-size: 100% 100%;
  width: 95%;
  margin: 0 auto;
  margin-top: 5%;
  color: #dcdee0;
  padding: 30px
}

.notice_content .text {
    background-color: rgb(201 255 255 / 27%);
    width: 85%;
    height: 80%;
    border-radius: 20px;
    padding: 10px;
    font-size: 14px;
}

.home_3 {
  width: 75%;
  display: block;
  margin: 0 auto;
}

// 导航条样式定制
.van-nav-bar {
  z-index: 999;
  background-color: #c21401;
  ::v-deep .van-nav-bar__title {
    color: #fff;
  }
}

// 搜索框样式定制
.van-search {
  position: fixed;
  width: 100%;
  top: 46px;
  z-index: 999;
}

// 分类导航部分
.my-swipe .van-swipe-item {
  height: 185px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  padding: 10px;
  height: 27%;
  margin-top: 5%;

}
.my-swipe .van-swipe-item img {
  width: 100%;
}

// 主会场
.main img {
  display: block;
  width: 100%;
}

// 猜你喜欢
.guess .guess-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
}

// 商品样式
.goods-list {
  background-color: #f6f6f6;
}
</style>